<template>
  <v-app id="inspire">
    <!-- Navigation Bar -->
    <app-navigation-drawer
      :orderCount="orderCount"
      @changeOrderCount="changeOrderCount($event)"
      @clearTimer="clearTimer($event)"
      v-model="drawer"
      v-if="authGuard.isAuthenticated()"
    ></app-navigation-drawer>

    <v-content>
      <router-view
        @drawer="changeDrawer"
        @setTimerOrder="setTimerOrder($event)"
        @changeOrderCount="changeOrderCount($event)"
      ></router-view>
    </v-content>
    <!-- App Footer -->
    <!-- <v-footer height="auto" class="white pa-3 mt-3" style="position:absolute;width: 100%; bottom: 0;" v-if="authGuard.isAuthenticated()">
      <span class="caption"><a href="http://cyberkingict.com/index" target="_blank"> Cyber King ICT Solutions</a> &copy; {{ new Date().getFullYear() }}</span>
      <v-spacer></v-spacer>
      <span class="caption mr-1"> Make With Love </span> <v-icon color="pink" small>favorite</v-icon>
    </v-footer>-->
  </v-app>
</template>

<script>
import NavigationDrawer from "./components/layout/NavigationDrawer";
import Login from "./components/login/Login";
import { AuthGuard } from "./helpers/auth-guard";
import { orderService } from "./services/order-service";

export default {
  data: () => ({
    authGuard: AuthGuard,
    drawer: true,
    orderCount: 0,
    timeout: null,
    user: JSON.parse(localStorage.getItem("user")),
  }),
  components: {
    appNavigationDrawer: NavigationDrawer,
    appLogin: Login,
  },
  props: {
    source: String,
  },
  mounted() {
    this.setTimerOrder();
  },
  methods: {
    changeDrawer: function (state) {
      this.drawer = state;
    },

    setTimerOrder() {
      this.user = JSON.parse(localStorage.getItem("user"));
      if (this.user) {
        if (this.user.roleName == "ADMIN") {
          this.getPendingOrderCount();
          this.timeout = setInterval(() => {
            this.getPendingOrderCount();
          }, 900000);
        }
      }
    },

    getPendingOrderCount: function () {
      orderService
        .getPendingOrderCount()
        .then((res) => {
          if (res.data) {
            this.orderCount = res.data;
          } else {
            this.orderCount = 0;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    changeOrderCount() {
      this.getPendingOrderCount();
    },

    clearTimer() {
      clearInterval(this.timeout);
    },
  },
};
</script>
<style>
@import "assets/css/style.css";

/*.container.fluid{*/
/*margin-bottom: 40px;*/
/*}*/
</style>